import { SelectInput } from "@impero-com/common/components/form/fields/selectInput";
import { t } from "@impero-com/common/utils/i18n";

import { CalendarView } from "api/generated/model";

import { useCalendarListQuery } from "./queries/useCalendarListQuery";

export interface CalendarSelectInputProps {
    value: number | null;
    onChange: (value: number | null) => void;
    initialCalendars: CalendarView[];
    label?: string;
    helpText?: string;
    disabled?: boolean;
    autoFocus?: boolean;
}

const DEFAULT_CALENDAR = "default";

export const CalendarSelectInput = ({
    value,
    onChange,
    initialCalendars,
    label,
    helpText,
    disabled,
    // Gives focus to this component when mounted
    autoFocus,
}: CalendarSelectInputProps) => {
    const { data: calendars } = useCalendarListQuery(initialCalendars);

    const displayValue = value ?? DEFAULT_CALENDAR;

    const handleChange = (selected: string | number | null | undefined) => {
        onChange(selected === DEFAULT_CALENDAR ? null : (selected as number));
    };

    const options = [
        {
            value: DEFAULT_CALENDAR,
            label: t("CreateControl_Recurrence_DateRule_Days"),
        } as const,
        ...calendars!.map(({ id, name }) => ({
            value: id,
            label: name,
        })),
    ];

    return (
        <SelectInput
            value={displayValue}
            onChange={handleChange}
            onBlur={() => {}}
            label={label}
            helpText={helpText}
            options={options}
            disabled={disabled}
            autoFocus={autoFocus}
        />
    );
};
